<template>
    <div class="event-actions">
        <button class="btn btn--primary" @click="doPublish">Опубликовать</button>
        <button class="btn" @click="doUnpublish">Снять с публикации</button>
        <button class="btn btn--danger" @click="cancelOpen = true">Отменить сессию</button>
        <button class="btn btn--primary" @click="bulkInviteOpen = true">Массовые приглашения</button>

        <CancelEventDialog
            v-if="cancelOpen"
            :open="cancelOpen"
            :event-id="eventId"
            @close="cancelOpen = false"
            @done="onDone"
        />

        <BulkInviteDialog
            v-if="bulkInviteOpen"
            :open="bulkInviteOpen"
            :event-id="eventId"
            @close="bulkInviteOpen = false"
            @done="onDone"
        />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelEventDialog from './CancelEventDialog.vue';
import BulkInviteDialog from './BulkInviteDialog.vue';

const props = defineProps<{ detail: { id: number | string } }>();

const cancelOpen = ref(false);
const bulkInviteOpen = ref(false);
const busy = ref(false);

const eventId = (): string => String(props.detail.id);

async function doPublish(): Promise<void> {
    if (!window.confirm('Опубликовать сессию?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${eventId()}/publish/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

async function doUnpublish(): Promise<void> {
    if (!window.confirm('Снять сессию с публикации?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${eventId()}/unpublish/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    bulkInviteOpen.value = false;
    window.location.reload();
}
</script>

<style scoped>
.event-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .event-actions .btn { min-height: 2.5rem; }
}
</style>
